import api from './config';

/**
 * 获取审计日志列表
 * @param {Object} params 查询参数
 */
export function getAuditLogs(params = {}) {
  return api.get('/audit/logs', { params });
}

/**
 * 获取审计统计数据
 */
export function getAuditStats() {
  return api.get('/audit/stats');
} 